import * as Sentry from '@sentry/react'
import { logGaNonInteractionEvent } from 'common/utils/analytics'

const SCRIPT_ERROR = 'JavaScriptError'

/* eslint-disable no-undef */
export const initErrorLogging = (history) => {
  const isProduction = process.env.NODE_ENV === 'production'
  if (isProduction) {
    Sentry.init({
      dsn: 'https://ca6fa777a6113ae58983361c35d823a5@o4505628143255552.ingest.sentry.io/4505667492315136',
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }),
        new Sentry.Replay(),
      ],
      environment: 'production',
      // Performance Monitoring
      tracesSampleRate: 0,  // 0% of requests/transactions will be monitored
      // Session Replay
      replaysSessionSampleRate: 0, // 0% of sessions without errors will be captured
      replaysOnErrorSampleRate: 0, // 0% of sessions with errors will be captured
    })
  }
}
/* eslint-enable no-undef */


export const logState = (state) => {
  Sentry.setContext('State', state)
}

export const logError = (error) => {
  Sentry.captureException(error)
  logGaNonInteractionEvent(SCRIPT_ERROR, 'UnexpectedError', error.message, error)
}
